<div class="t-popup popup-graphs" style="display: block; height: 100%">
  <div class="popup-close"></div>

  <div class="popup-frame">
    <div class="patient-ob-box popup-body">
      <div class="h100 m-box" *ngIf="!isReports">
        <h2>Exam Search</h2>
        <div>
          <strong style="margin-right: 0.5em"> From: </strong>
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [min]="searchmin"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
            style="margin-right: 1em"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          <strong style="margin-right: 0.5em"> Until: </strong>
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [max]="searchmax"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            style="margin-right: 1em"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </div>
        <div class="h100 l-flex l-column">
          <div class="l-fg1">
            <div class="">
              <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="etype"
                    class="custom-check"
                    value="All"
                    (click)="setVals('All')"
                  />
                  <i class="customInput-display"></i>
                  <span> All </span>
                </label>

                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="etype"
                    class="custom-check"
                    value="Eyes"
                    (click)="setVals('Eyes')"
                  />
                  <i class="customInput-display"></i>
                  <span> Eyes </span>
                </label>
              </div>
              <div class="linked-radios-list linked-radios-set">
                <ng-container *ngIf="etype == 'Eyes'">
                  <ng-container
                    *ngIf="
                      loginService.premissions &&
                      !loginService.premissions.OCTOptic &&
                      !loginService.premissions.OCTMacular
                    "
                  >
                    <label class="linked-radios-item" (click)="setE($event, 'OCT')">
                      <input type="checkbox" name="OCT" [checked]="exams['OCT']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">OCT</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.OCTOptic">
                    <label class="linked-radios-item" (click)="setE($event, 'OCTOptic')">
                      <input type="checkbox" name="OCT Optic" [checked]="exams['OCTOptic']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">OCT Optic</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.OCTMacular">
                    <label class="linked-radios-item" (click)="setE($event, 'OCTMacular')">
                      <input type="checkbox" name="OCT Macular" [checked]="exams['OCTMacular']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">OCT Macular</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.TOPEye">
                    <label class="linked-radios-item" (click)="setE($event, 'TOPEye')">
                      <input type="checkbox" name="TOP" [checked]="exams['TOPEye']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">TOP</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.FOV">
                    <label class="linked-radios-item" (click)="setE($event, 'FOV')">
                      <input type="checkbox" name="FOV" [checked]="exams['FOV']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">FOV</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.Pachymetry">
                    <label class="linked-radios-item" (click)="setE($event, 'Pachymetry')">
                      <input type="checkbox" name="Pachymetry" [checked]="exams['Pachymetry']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">Pachymetry</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="loginService.premissions && loginService.premissions.Fundus">
                    <label class="linked-radios-item" (click)="setE($event, 'Fundus')">
                      <input type="checkbox" name="Fundus" [checked]="exams['Fundus']" />
                      <span class="linked-radios-row">
                        <span class="l-fg1 linked-radios-title">Fundus</span>
                        <span class="linked-radios-duration"></span>
                        <span class="linked-radios-counter"><i>1</i></span>
                      </span>
                    </label>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
            <a class="btn-primary -exit" (click)="closed.emit(null)" style="padding-top: 1em">
              Cancel
            </a>
            <button class="btn-primary -search" (click)="search()" *ngIf="cansearch">Search</button>
          </div>
        </div>
      </div>
      <!-- ================ Is Reports Search (Start) ================ -->
      <div class="h100 m-box" *ngIf="isReports">
        <h2 *ngIf="!loginService.premissions['NoExams']">Exam Search</h2>
        <h2 *ngIf="loginService.premissions['NoExams']">Maccabi Report</h2>
        From
        <input
          [matDatepicker]="startDatepicker"
          [(ngModel)]="startdate"
          class="t-field t-field--date menstural-field"
          aria-labelledby="menstural_LMP"
          (click)="startDatepicker.open()"
        />
        <mat-datepicker #startDatepicker></mat-datepicker>
        Until
        <input
          [matDatepicker]="endDatepicker"
          [(ngModel)]="enddate"
          (click)="endDatepicker.open()"
          class="t-field t-field--date menstural-field"
          aria-labelledby="menstural_LMP"
        />
        <mat-datepicker #endDatepicker></mat-datepicker>
        <div class="h100 l-flex l-column">
          <div class="l-fg1" *ngIf="!loginService.premissions['NoExams']">
            <div class="">
              <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="reportstype"
                    class="custom-check"
                    value="AllReports"
                    (click)="setVals('AllReports')"
                  />
                  <i class="customInput-display"></i>
                  <span> All </span>
                </label>
                <label class="t-label-top" *ngIf="loginService.isAdmin">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="reportstype"
                    class="custom-check"
                    value="Refferelnum"
                    (click)="setVals('Refferelnum')"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    Missing Refferel number
                    <select
                      class="t-field t-select"
                      *ngIf="reportstype == 'Refferelnum'"
                      [(ngModel)]="hmostype"
                    >
                      <option value="Macabi">מכבי</option>
                      <option value="Leumit">לאומית</option>
                      <option value="Meuhedet">מאוחדת</option>
                      <option value="Clalit">כללית</option>
                      <option value="Private">פרטי</option>
                      <option value="IDF">צהל</option>
                      <option value="null">לא שויכו</option>
                    </select>
                  </span>
                </label>
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="reportstype"
                    class="custom-check"
                    value="HMO"
                    (click)="setVals('HMO')"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    BY HMO
                    <select class="t-field t-select" *ngIf="reportstype == 'HMO'" [(ngModel)]="hmostype">
                      <option value="Macabi">מכבי</option>
                      <option value="Leumit">לאומית</option>
                      <option value="Meuhedet">מאוחדת</option>
                      <option value="Clalit">כללית</option>
                      <option value="Private">פרטי</option>
                      <option value="IDF">צהל</option>
                      <option value="null">לא שויכו</option>
                    </select>
                  </span>
                </label>
                <label class="t-label-top" *ngIf="loginService.isAdmin">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="reportstype"
                    class="custom-check"
                    value="Clalit"
                    (click)="setVals('Clalit')"
                  />
                  <i class="customInput-display"></i>
                  <span> Sent to Clalit</span>
                </label>
              </div>
            </div>
          </div>
          <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
            <a class="patient-ob-btn -exit" (click)="closed.emit(null)" style="padding-top: 1em">
              Cancel
            </a>
            <button class="patient-ob-btn -search" (click)="search()" *ngIf="cansearch">Search</button>
          </div>
        </div>
      </div>
      <!-- ================ Is Reports Search (End) ================ -->
    </div>
  </div>
</div>
